import { DataTable } from './DataTable'
import { Button, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { settleConfigModel } from '../settleConfigModel'

export const DataBox = () => {

    const {
        selectedRowKeys, setMode, setVisible
    } = settleConfigModel()

    const action = (
        <>
            <Button shape="round" onClick={() => { setMode("add"); setVisible(true); }} type="primary">
                添加
            </Button>
            <Button shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning("请选择需要编辑的数据！")
                        return
                    }
                    setMode("edit");
                    setVisible(true)
                }}
                type="primary">
                编辑
            </Button>
        </>
    )

    return (
        <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
            <DataTable />
        </YhBox>
    )
}
